import React from "react";
// @material-ui/core components

// core components
import GridContainer from "../../../components/Grid/GridContainer.js";
import GridItem from "../../../components/Grid/GridItem.js";
import featuresStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import { Box } from "@mui/material";
import { getBaseSxStyle } from "../../../utils/getSxStyle.js";



export default function SectionFeatures({ ...rest }) {

  return (
    <div className="cd-section" {...rest}>
      <Box sx={getBaseSxStyle(featuresStyle, ['container'])}>
        {/* Feature 2 START */}
        <Box sx={getBaseSxStyle(featuresStyle, ['features2'])}>
          <GridContainer>
            <GridItem
              sx={getBaseSxStyle(featuresStyle, ['mlAuto', 'mrAuto', 'textCenter'])}
              xs={12}
              sm={12}
              md={12}
            >
              <h2 style={{ textAlign: 'left' }}>
                Tehnička podrška
              </h2>

              <h5 style={{ textAlign: 'left' }}>
                Ukoliko imate bilo kakve probleme ili sugestije u vezi sa radom aplikacije možete nas kontaktirati na
                support@smartpart.app
              </h5>

            </GridItem>
            <GridItem
              sx={getBaseSxStyle(featuresStyle, ['mlAuto', 'mrAuto', 'textCenter'])}
              xs={12}
              sm={12}
              md={12}
            >

              <h2 style={{ textAlign: 'left' }}>
                Brisanje naloga
              </h2>

              <h5 style={{ textAlign: 'left' }}>
                Ukoliko želite da obrišete nalog to možete uraditi tako što ćete sa email adrese sa kojom ste kreirali nalog poslati poruku na: <br />
                brisanje.naloga@smartpart.app<br />
                Vaš nalog i podaci će biti obrisani u roku od 90 dana.
              </h5>
            </GridItem>

          </GridContainer>

        </Box>


      </Box>

    </div>
  );
}
